/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { ApplicationConfig, enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MsalInterceptor, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalGuard, MsalBroadcastService } from '@azure/msal-angular';
import { modals, componentServices } from './app/app-module-imports';
import { AppMonitoringService } from './app/AppMonitoringService';
import { MSALGuardConfigFactory } from './app/auth/MSALGuardConfigFactory';
import { MSALInstanceFactory } from './app/auth/MSALInstanceFactory';
import { MSALInterceptorConfigFactory } from './app/auth/MSALInterceptorConfigFactory';
import { RoleAuthGuard } from './app/auth/RoleAuthGuard';
import { ErrorHandlerService, HttpErrorInterceptor } from './app/modals/error-modal/error-handler.service';
import { ApiService } from './app/shared/ApiService';
import { CurrentUserService } from './app/shared/CurrentUser.service';
import { FormControlHelper } from './app/shared/helpers/FormControlHelper';
import { SearchHelper } from './app/shared/helpers/SearchHelper';
import { AppInfoService } from './app/singletons/app-info.service';
import { SettingsService } from './app/utility/SettingsService';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

//const providers = [
//  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
//];

const providers: ApplicationConfig = {
  providers: [
    //{
    //  provide: APP_ID,
    //  useValue: 'ng-cli-universal'
    //},
    provideAnimations(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    AppInfoService,
    ApiService,
    AppMonitoringService,
    SettingsService,
    CurrentUserService,
    ErrorHandlerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    RoleAuthGuard,
    SearchHelper,
    FormControlHelper,
    ...modals,
    ...componentServices,
  ]
};

bootstrapApplication(AppComponent, providers); 

if (environment.production) {
  enableProdMode();
}
